export const CHART_BRAND = 'hsl(var(--brand-fg))'
export const CHART_BLUE = '#60A5FA'
export const CHART_PURPLE = '#A78BFA'
